import React from 'react';
import styled from 'styled-components';
import formatHTMLMessage from '@99designs/frontend-components/i18n/formatHTMLMessage';
import Heading from '../../../../shared/components/Heading';
import { colors, spaces } from '../../../../shared/lib/styles';
import { ContestType } from '../ContestOverviewData';

interface Props {
    contest: ContestType;
}

const Component = styled.div`
    text-align: center;

    &::before,
    &::after {
        content: '';
        display: block;
        margin-left: auto;
        margin-right: auto;
        height: 80px;
        width: 2px;
        background-color: ${colors.grey300};
    }

    &::before {
        margin-bottom: ${spaces.space8}px;
    }

    &::after {
        margin-top: ${spaces.space8}px;
    }

    em {
        color: ${colors.grey800};
        font-style: normal;
    }
`;

function ContestCallout({ contest }: Props) {
    const { category, owner } = contest;

    return (
        <Component>
            <Heading type="h2" variations={['h5', 'soft', 'no-margin']}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: formatHTMLMessage(
                            __("Check out <em>{owner}'s</em> {categoryName} contest…"),
                            {
                                owner: owner.displayName,
                                categoryName: category.title,
                            }
                        ),
                    }}
                />
            </Heading>
        </Component>
    );
}

export default ContestCallout;
